<div
	class="c-check-button"
	id="id"
	role="checkbox"
	tabindex="0"
	[title]="title"
	[class.c-check-button--checked]="isChecked"
	[class.c-check-button--disabled]="disabled"
	[class.c-check-button--with-icon]="withIcon"
	[attr.aria-checked]="isChecked ? 'true' : 'false'"
	[attr.aria-disabled]="disabled ? 'true' : 'false'"
	[attr.aria-label]="title"
	(click)="onChange(!isChecked)"
	(keydown)="onKeyDown($event)"
>
	<ng-content></ng-content>
</div>
